import React from "react";
import toast from "react-hot-toast";
import SuccessToast from "components/Toast/SuccessToast";

const vgToast = {
  success: (message: string) =>
    toast.custom(
      (t) =>
        React.createElement(SuccessToast, {
          toast: t,
          title: message,
          onDismiss: () => toast.dismiss(t.id),
        }),
      { duration: 3000 }
    ),
  error: (message: string) => toast.error(message, { duration: 5000 }),
  info: (message: string) => toast(message, { duration: 4000 }),
  loading: (message: string) => toast.loading(message),
  dismiss: (id?: string) => toast.dismiss(id),
};

export default vgToast;
